import { Button, Form, message, Input, Col, Row } from 'antd';
import { Link } from 'react-router-dom';
import AppHeader from 'components/AppHeader';
import React, { useState, useEffect } from 'react';
import promoCodeApis from 'api/promoCodeApis';
import { ContentRow } from 'components/ThemeComponents';
import { StyledTable, OFFSET_HEADER } from 'components/ThemeComponents';
import { fullDateTimeFormat, onlyDateFormat } from 'helpers/dateTimeHelper';

export default function ListPromoCodesPage() {

  const [promoCodes, setPromoCodes] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [paginate, setPaginate] = useState({})
  const [searchForm] = Form.useForm();

  async function fetchPromoCodes(params={}) {
    setIsFetching(true);
    try {
      const res = await promoCodeApis.listing(params);
      if (res.code === 200) {
        setPromoCodes(res.data ?? []);
        setPaginate({page: res.page, limit: res.limit, total: res.total})
      }
    } catch (error) {
      message.info(error.message);
    }
    setIsFetching(false);
  }

  useEffect(() => {
    fetchPromoCodes()
  }, []);

  const onChangeTable = async(pagination, filters, sorter) => {
    console.log(sorter)
    var params = {
      page: pagination.current,
      limit: pagination.pageSize,
      data_sort: sorter.columnKey,
      order_sort: sorter.order
    }
    const args = Object.assign({}, params, searchForm.getFieldsValue())
    await fetchPromoCodes(args)
  }

  const onFinishSearchForm = async (values) => {
    const params = values || {}
    console.log(params)
    await fetchPromoCodes(params)
  };

  const bottom = 'bottomRight';

  const columns = [
    {
      title: 'ID',
      width: '15rem',
      render: (record) => <span>{record.id}</span>
    },
    {
      title: 'code',
      width: '15rem',
      render: (record) => <span>{record.code}</span>
    },
    {
      title: 'status',
      width: '10rem',
      ellipsis: {
        showTitle: false
      },
      render: (record) => <span>{record.status}</span>
    },
    {
      title: 'promo_code_type',
      width: '10rem',
      render: (record) => <span>{record.promo_code_type}</span>
    },
    {
      title: 'quota_credit',
      width: '10rem',
      ellipsis: {
        showTitle: false
      },
      render: (record) => <span>{record.quota_credit}</span>
    },
    {
      title: 'number_of_days',
      width: '10rem',
      ellipsis: {
        showTitle: false
      },
      render: (record) => <span>{record.number_of_days}</span>
    },
    {
      title: 'expired_at',
      width: '10rem',
      ellipsis: {
        showTitle: false
      },
      render: (record) => <span>{onlyDateFormat(record.expired_at)}</span>
    },
    {
      title: 'created_by_email',
      width: '10rem',
      ellipsis: {
        showTitle: false
      },
      render: (record) => <span>{record.created_by_email}</span>
    },
    {
      title: 'updated_by_email',
      width: '10rem',
      ellipsis: {
        showTitle: false
      },
      render: (record) => <span>{record.updated_by_email}</span>
    },
    {
      title: 'created_at',
      width: '10rem',
      key: 'created_at',
      sorter: true,
      ellipsis: {
        showTitle: false
      },
      render: (record) => <span>{fullDateTimeFormat(record.created_at)}</span>
    },
    {
      title: 'updated_at',
      width: '10rem',
      ellipsis: {
        showTitle: false
      },
      render: (record) => <span>{fullDateTimeFormat(record.updated_at)}</span>
    },
    {
      title: 'Chức năng',
      width: '10rem',
      render: (record) => (
        <>
          <p>
            <Button type="primary">
              <Link to={`/promo_codes/${record.id}`}>Cập nhật</Link>
            </Button>
          </p>
        </>
      )
    }
  ];
  
  return (
    <>
      <AppHeader
        fixedTop
        pageTitle="Tất cả promoCodes"
        pageHeaderExtras={[
          <Button type="primary">
            <Link to={'/promo_codes/new'}>Thêm mới</Link>
          </Button>
        ]}
      />
      <br />
      <ContentRow capped>
      <Form
          form={searchForm}
          name="advanced_search"
          className="ant-advanced-search-form"
          onFinish={onFinishSearchForm}
          style={{marginBottom: "40px"}}
        >
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                name='code'
                label='code'
              >
                <Input placeholder="Tìm theo code" />
              </Form.Item>
            </Col>
            <Col
              style={{
                textAlign: 'right',
              }}
            >
              <Button type="primary" htmlType="submit">
                Search
              </Button>
              <Button
                style={{
                  margin: '0 8px',
                }}
                onClick={() => {
                  searchForm.resetFields();
                  onFinishSearchForm();
                }}
              >
                Clear
              </Button>
            </Col>
          </Row>
        </Form>
        <StyledTable
          sticky={{ offsetHeader: OFFSET_HEADER }}
          size="small"
          scroll={{ x: 1000 }}
          loading={isFetching}
          rowKey="id"
          // @ts-ignore
          columns={columns}
          dataSource={promoCodes}
          onChange={onChangeTable}
          pagination={{
            defaultPageSize: paginate.limit,
            defaultCurrent: paginate.page,
            total: paginate.total,
            position: [bottom],
            showTotal: (total, range) => (
              <span style={{ left: 0, position: 'absolute' }}>
                Hiển thị {range[0]}-{range[1]} của {total} tin đã đăng
              </span>
            )
          }}
        />
      </ContentRow>
    </>
  );
}

